export default __webpack_public_path__ + "static/media/cement1.22b3ec8e.mp4";